/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zhuxuxi
 * @Date: 2022-11-17 17:34:00
 * @LastEditTime: 2023-08-14 14:24:27
 */
module.exports = {
  system: {
    titleTop: '宁德市海洋预报专项网站',
    title: '宁德市海洋预报台',
    titleEn: 'Ningde Marine Forecast'
  },
  btns: {
    lang: 'English'
  },
  section: ['水乡渔村', '海洋科普宣传', '关注我们']
}
